export default __webpack_public_path__ + "static/shopifyLogo-f35d3754c673871dc218de2357516b2c.svg";